// Learning Hub forum — matches `learning_hub_discussions.type` (DB check constraint).

export const LEARNING_HUB_DISCUSSION_TYPE_OPTIONS = [
  { key: 'Question', value: 'Question' },
  { key: 'Share a Resource', value: 'Share a Resource' },
  { key: 'Community Building', value: 'Community Building' },
  { key: 'General', value: 'General' },
  { key: 'Assignment', value: 'Assignment' },
  { key: 'Course Forum', value: 'Course Forum' },
]
